export enum TimePeriod {
  TODAY = "day",
  WEEK = "week",
  MONTH = "month",
  YEAR = "year",
}
